module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f91f.3dc67b93.svg";